import {
  TwoFactorSmsOption,
  TwoFactorStandardOption,
} from "@/components/Welcome/AuthenticatorSetup/AuthenticatorSetupForm";

/** Must render inside an ancestor `RadioGroup` (see `TwoFactorChangeAppView`, which owns the form). */
export const TwoFactorAppAlternatives = () => {
  return (
    <div className="flex flex-col gap-8">
      <TwoFactorSmsOption />
      <TwoFactorStandardOption />
    </div>
  );
};
